import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_GEOLOCATION_URL

export const storeAlias = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: '/geocode/alias',
    data,
  })

  return response?.data
}